import styled from 'styled-components'
import { primary } from '../../assets/colorPallet'


const TitleH4 = styled.h4`
    font-size: ${props => {
        if (props.small) return "16px"
        else if (props.medium) return "18px"
        else if (props.large) return "20px"
        else if (props.xLarge) return "36px"
        else if (props.xXLarge) return "56px"
        else return "18px"
    }};
    font-weight: ${props => {
        if (props.bold) return "600"
        else if (props.regular) return "400"
        else return "500"
    }};
    color: ${props => {
    if (props.primary) return primary
    else if (props.white) return "white"    
    else if (props.color) return props.color
    else return "#333"
}};
    cursor: ${props => props.pointer ? "pointer" : null};
    margin: 0;
    padding: 0;
    line-height: ${props => props.lineHeight ? props.lineHeight : "24px"};
    text-align: ${props => props.center ? "center" : null};
    
    @media only screen and (max-width: 600px) {
          font-size: ${props => {
            if (props.small) return "16px"
            else if (props.medium) return "16px"
            else if (props.large) return "18px"
            else if (props.xLarge) return "32px"
            else if (props.xXLarge) return "56px"
            else return "18px"
          }};
    }
`

export default TitleH4
